module.exports = __webpack_public_path__ + "img/engeland.5f2fa177.png";